import { registrationApplicationsSlice } from '../slices/regApps';

export const {
  setIsMailSending,
  setIsRegistrationApplicationsLoading,
  clearRegistrationApplications,
  setNewApplicationsCount,
} = registrationApplicationsSlice.actions;
